import { UserSearchParams, UserSearchResponse } from '../_types/user.types';
import { ApiEndpoints } from '../constantes/ApiEndpoints';
import { apiUserAccount } from '../../../services/api/ApiService';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

export const useUserSearchService = () => ({
  async searchUserService(data: UserSearchParams): Promise<UserSearchResponse> {
    const schemaId = getSchemaIdFromStorage();

    return await apiUserAccount.post<UserSearchResponse>(`${ApiEndpoints.auth.userSearch}?schemaId=${schemaId}`, {
        username: data.username
      }
    );
  }
});
 